'use client';

import { useEffect } from 'react';
import type { AdobeAnalyticsUser } from '../../../lib/util/adobeAnalytics';
import {
  buildAdobePageData,
  pushAdobePageLoadOnce,
} from '../../../lib/util/adobeAnalytics';

type Props = {
  initialAsPath?: string | null;
  initialPathname?: string | null;
  user?: AdobeAnalyticsUser | null;
};

/**
 * Tracks the initial Adobe pageLoad event after the browser hydrates.
 */
const AdobeAnalyticsInitialPageTracker = ({
  initialAsPath = '',
  initialPathname = '',
  user,
}: Props) => {
  useEffect(() => {
    const pageData = buildAdobePageData({
      asPath: initialAsPath,
      pathname: initialPathname,
      user,
    });

    pushAdobePageLoadOnce(pageData);
  }, [initialAsPath, initialPathname, user]);

  return null;
};

export default AdobeAnalyticsInitialPageTracker;
